import styled from 'styled-components';

import { DefaultRow } from 'assets/styled/sheets/components/Forms';

export const StyledFieldRow = styled.div`
  ${DefaultRow}
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '0')};
  margin-top: ${props => (props.marginTop ? props.marginTop : '0')};
`;
